module.exports = __webpack_public_path__ + "img/dashiji-1996.c4da3717.jpg";